import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { examinerScope } from '../../utils/examinerApi';
import ExaminerAuthoring from './ExaminerAuthoring';
import ExaminerSettings from './ExaminerSettings';
import ExaminerSetup from './ExaminerSetup';
import './examiner.css';
import useExaminerVisibility from '../../utils/useExaminerVisibility';

const ManagementWorkspace = ({ user }) => {
  const admin = ['admin', 'superuser'].includes(user.orgRole);
  const [tab, setTab] = useState('limits');
  const [advanced, setAdvanced] = useState(false);
  const instructor = user.orgRole === 'instructor' || (admin && [true, 1, '1', 'true'].includes(user.isInstructor));
  return <section className="examiner" aria-label="Examiner management">
    <h2>AI Mock Examiner management</h2>
    <div className="examiner-actions">
      {admin && <button aria-pressed={tab === 'limits'} onClick={() => setTab('limits')}>Usage limits</button>}
    </div>
    <p>To take a mock oral, open Training, choose the checkride and aircraft, and start. No curriculum setup is part of the examination flow.</p>
    <details onToggle={event => setAdvanced(event.currentTarget.open)}>
      <summary>Advanced staff tools</summary>
      {advanced && <>
        <p>Optional diagnostics and independent content review for staff, not student setup.</p>
        <button aria-pressed={tab === 'setup'} onClick={() => setTab('setup')}>Checkride setup</button>
        <button aria-pressed={tab === 'authoring'} onClick={() => setTab('authoring')}>Instructor authoring / review</button>
        <div hidden={tab !== 'setup'}><ExaminerSetup canReview={instructor && (!user.status || user.status === 'active')} onReview={() => setTab('authoring')} /></div>
        {tab === 'authoring' && <ExaminerAuthoring canReview={instructor && (!user.status || user.status === 'active')} />}
      </>}
    </details>
    {tab === 'limits' && admin && <ExaminerSettings />}
  </section>;
};

export default function ExaminerManagement() {
  const { currentUser, currentOrg } = useApp();
  const showExaminer = useExaminerVisibility();
  const user = currentUser?.user;
  if (!showExaminer || !currentUser?.sessionId || !['admin', 'superuser', 'instructor'].includes(user?.orgRole)) return null;
  return <ManagementWorkspace key={`${examinerScope(currentUser)}:${currentOrg?.id}`} user={user} />;
}
